import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '@/views/customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { systemConfigStore, systemConfigEdit } from '../request';
export default {
  props: {
    type: {
      type: String,
      required: true,
      default: ''
    },
    language: {
      type: String,
      required: true,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      action: uploadFile,
      uploadStatus: false,
      previewVisible: false,
      previewSrc: '',
      // 简体
      form: {
        icon: '',
        copyWriting: ''
      },
      fileList: [],
      btnShow: 1,
      //1:保存 2:编辑 3:取消
      isEdit: true,
      //是否可编辑
      oldForm: {},
      disableBtn: false
    };
  },
  computed: {
    rules() {
      return {
        icon: [{
          required: true,
          message: this.$t('请上传icon'),
          trigger: 'change'
        }],
        copyWriting: [{
          required: true,
          message: this.$t('请输入文案设置'),
          trigger: 'blur'
        }]
      };
    }
  },
  mounted() {
    // 判断传过来的是否有值，有值赋值，没值使用form默认值
    if (this.item[this.language]) {
      this.form = this.item[this.language];
      this.fileList = [{
        uid: '-1',
        name: 'image.png',
        status: 'done',
        url: this.form.icon
      }];
      this.btnShow = 2;
      this.isEdit = false;
      this.oldForm = JSON.parse(JSON.stringify(this.form));
    } else {
      this.btnShow = 1;
      this.isEdit = true;
    }
  },
  methods: {
    previewImg() {
      this.previewSrc = this.form.icon;
      this.previewVisible = true;
    },
    // 保存
    saveForm() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          var _this$form;
          this.disableBtn = true;
          let res;
          if ((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.id) {
            // 编辑
            const params = Object.assign({}, this.form, {
              id: this.form.id,
              type: this.type,
              language: this.language
            });
            res = await systemConfigEdit(params);
          } else {
            const params = Object.assign({}, this.form, {
              type: this.type,
              language: this.language
            });
            res = await systemConfigStore(params);
            this.form.id = res;
          }
          if (res) {
            this.$message.success(this.$t('保存成功'));
            this.btnShow = 2;
            this.isEdit = false;
            this.oldForm = JSON.parse(JSON.stringify(this.form));
            this.disableBtn = false;
          }
        }
      });
    },
    // 编辑
    editForm() {
      this.btnShow = 3;
      this.isEdit = true;
    },
    // 取消-
    cancelForm() {
      this.btnShow = 2;
      this.isEdit = false;
      // 数据重置
      this.form = JSON.parse(JSON.stringify(this.oldForm));
      this.form.icon = this.oldForm.icon;
      this.fileList = [{
        uid: '-1',
        name: 'image.png',
        status: 'done',
        url: this.form.icon
      }];
      // 清除错误提示
      this.$refs.ruleForm.clearValidate();
    },
    // 前后空格去除
    handleBlurTrim(field) {
      this.form[field] = this.form[field].trim();
    },
    // icon上传
    handleChange({
      fileList
    }) {
      if (fileList.length == 0) {
        this.fileList = [];
        this.form.icon = '';
        this.previewSrc = '';
        return false;
      } else if (this.uploadStatus == false) {
        this.fileList = [];
        this.form.icon = '';
        return false;
      }
      let url = '';
      this.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
          url = file.url;
        }
        return file;
      });
      if (url) {
        this.form.icon = url;
      }
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请上传正确的图片格式'));
      }
      const isLt5k = file.size / 1024 < 500;
      if (!isLt5k) {
        this.$message.error(this.$t('上传图片应小于') + '500kb');
      }
      this.uploadStatus = isJpgOrPng && isLt5k;
      return this.uploadStatus;
    }
  }
};